// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { Box, Grid, Typography, Paper, IconButton, Button } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import config from "../../../Config/clientConfig.json";
// import { callAPI, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
// import { useNavigate, useParams } from "react-router-dom";
// import SaveIcon from "@mui/icons-material/Save";




// interface Bank {
//   BankId: string;
//   BankName: string;

// }

// interface ChequeData {
//   ChequeNumber: string;
//   ChequeDate: string;
//   Amount: number;
//   BankId: string;
//   PartyType: string;
//   PartyId: string;
//   ChequeType: string;
//   DueDate: string;
//   Remarks: string;

// }

// interface Customer {
//   CustomerId: string;
//   CustomerName: string;

// }

// const ChequeEntry = () => {
//   useEffect(() => {
//     updateMainHeader("Cheque Management");
//   }, []);

//   breadCrumbsStore.updateBreadCrumbs([
//     { "User Management": "/user/list" },
//   ]);

//   const [loading, setLoading] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedId, setSelectedId] = useState<string | number>(0);
//   const [isPopupOpen, setPopupOpen] = useState(false);
//   const { showMessage } = useSnackbar();
//   const params = useParams();
//   const id = params.id;
//   const navigate = useNavigate();

//   // ✅ Properly typed state
//   const [bank, setBank] = useState<Bank[]>([]);
//   const [customer, setCustomer] = useState<Customer[]>([]);

//   const {
//     control,
//     handleSubmit,
//     reset,
//     formState: { isValid },
//   } = useForm({
//     mode: "onChange",
//     defaultValues: {
//       ChequeDate: "",
//       Amount: "",
//       Location: "",
//       PartyType: "",
//       PartyId: "",
//       ChequeType: "",
//       DueDate: "",
//       Remarks: "",
//     },
//   });

//   const fetchDropdownData = async () => {
//     try {
//       const [bankRes, customerRes] = await Promise.all([
//         callAPI("banks/list", Method.GET),
//         callAPI("customers/list", Method.GET),
//       ]);

//       if (bankRes?.success) setBank(bankRes.data.results || []);
//       if (customerRes?.success) customerRes(bankRes.data.results || []);
//     } catch (error) {
//       console.error("Failed to fetch dropdown data:", error);
//     }
//   };

//   useEffect(() => {

//     if (!id || id === "undefined" || id === "null" || id.trim() === "") {
//       setIsEditMode(false);
//       reset();
//       fetchDropdownData();
//       return;
//     }

//     fetchDropdownData();
//   }, [id, reset]);

//   const onSubmit = async (data: any) => {
//     try {
//       setLoading(true);
//       const requestBody: ChequeData = {
//         ChequeNumber: data.ChequeNumber?.trim() || "",
//         ChequeDate: data.ChequeDate || new Date().toISOString(),
//         Amount: parseFloat(data.Amount) || 0,
//         BankId: data.BankId || "",
//         PartyType: data.PartyType || "Customer",
//         PartyId: data.PartyId || "",
//         ChequeType: data.ChequeType || "Received",
//         DueDate: data.DueDate || new Date().toISOString(),
//         Remarks: data.Remarks?.trim() || "",
//       };


//       let response;

//       response = await callAPI("cheques/create", Method.POST, requestBody);


//       if (response?.success) {
//         showMessage(
//           "Opening stock created successfully!",
//           "success"
//         );
//         navigate("/chequeentry/list");
//       } else {
//         showMessage(response?.message || "Operation failed", "error");
//       }
//     } catch (error: any) {
//       console.error("❌ Submit error:", error);
//       showMessage(error?.message || "Operation failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };


//   return (
//     <Box sx={{ p: 3, background: "#ececec", minHeight: "100vh" }}>

//       {}
//       <Typography sx={{ fontSize: "22px", fontWeight: 600, mb: 3 }}>
//         Cheque Entry
//       </Typography>

//       {}
//       <Paper sx={{ borderRadius: "16px", p: 4, background: "#fff" }}>

//         {}
//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
//           <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
//             Cheque Details
//           </Typography>
//           <Box>
//             <IconButton
//               sx={{ background: "#000", color: "#fff" }}
//               onClick={handleSubmit(onSubmit)}
//               disabled={!isValid || loading}
//             >
//               <SaveIcon fontSize="small" />
//             </IconButton>
//           </Box>
//         </Box>

//         {}
//         <Grid container spacing={4} mb={4}>

//           <Grid item xs={12} md={6}>

//             <WSTextField
//               name="ChequeNumber"
//               label="Cheque Number"
//               control={control}
//               id="ChequeNumber"

//             />

//           </Grid>
//           <Grid item xs={12} md={3}>

//             <WSSelectField
//               name="status"
//               label="Status"
//               control={control}
//               id="status"
//               options={config.statusConfig.staticOptionData}
//             />

//           </Grid>
//           <Grid item xs={12} md={3}>

//             <WSSelectField
//               name="chequetype"
//               label="Cheque Type"
//               control={control}
//               id="chequetype"
//               options={config.chequetypeConfig.staticOptionData}
//             />
//           </Grid>
//         </Grid>

//         {}
//         <Grid container spacing={4} mb={4}>
//           <Grid item xs={12} md={3}>
//             <WSDateField
//               name="ChequeDate"
//               label="Cheque Date"
//               control={control}
//               id="ChequeDate"
//               rules={undefined}
//             />
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <WSSelectField
//               name="BankId"
//               label="Bank"
//               control={control}
//               id="BankId"
//               options={bank.map(bank => ({
//                 value: bank.BankId,
//                 label: bank.BankName
//               }))}
//             />
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <WSTextField
//               name="Amount"
//               label="Amount"
//               control={control}
//               id="Amount"
//               type={TextType.AllowOnlyNumber}
//             />
//           </Grid>
//          <Grid item xs={12} md={3}>
//   <WSSelectField
//     name="PartyType"
//     label="Party Type"
//     control={control}
//     id="PartyType"
//     options={[
//       { value: "Customer", label: "Customer" },
//       { value: "Supplier", label: "Supplier" },
//       // Add other party types as needed
//     ]}
//   />
// </Grid>
//         </Grid>

//         {}
//         <Grid container spacing={4} mb={6}>
//           <Grid item xs={12} md={3}>
//   <WSSelectField
//     name="PartyId"  // ✅ Use PartyId field
//     label="Party"
//     control={control}
//     id="PartyId"
//     options={customer.map((cust) => ({
//       value: cust.CustomerId,
//       label: cust.CustomerName  
//     }))}
//   />
// </Grid>
//           <Grid item xs={12} md={3}>
//             <WSDateField
//               name="duedate"
//               label="Due Date"
//               control={control}
//               id="duedate"
//               rules={undefined}
//             />
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <WSTextField
//               name="remarks"
//               label="Remarks"
//               control={control}
//               id="remarks"
//               placeholder="Type something"
//             />
//           </Grid>
//         </Grid>

        
//       </Paper>
//     </Box>
//   );
// };

// export default ChequeEntry;



import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { Box, Grid, Typography, Paper, IconButton, Button, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSDateField from "../../../Components/DateField/WSDateField";
import config from "../../../Config/clientConfig.json";
import { callAPI, formatDate, Method, updateMainHeader, fetchAllPaginated } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import AddIcon from "@mui/icons-material/Add";


interface Bank {
  BankId: string;
  BankName: string;
}

interface Customer {
  CustomerId: string;
  CustomerName: string;
}

interface Supplier {
  SupplierId: string;
  SupplierName: string;
}

interface ChequeData {
  ChequeNumber: string;
  ChequeDate: string;
  Amount: number;
  BankId: string;
  PartyType: string;
  PartyId: string;
  ChequeType: string;
  DueDate: string;
  Remarks: string;
}

const ChequeEntry = () => {
  useEffect(() => {
    updateMainHeader("Cheque Management");
  }, []);

  breadCrumbsStore.updateBreadCrumbs([
    { "User Management": "/user/list" },
  ]);

  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const { showMessage } = useSnackbar();
  const params = useParams();
  const id = params.id;
  const navigate = useNavigate();

  // State for dropdown data
  const [banks, setBanks] = useState<Bank[]>([]);
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [partyOptions, setPartyOptions] = useState<{ value: string; label: string }[]>([]);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      ChequeNumber: "",
      ChequeDate: "",
      Amount: "",
      BankId: "",
      PartyType: "Customer",
      PartyId: "",
      ChequeType: "",
      DueDate: "",
      Remarks: "",
      status: "",
      chequetype: "",
      duedate: "",
      Attachments: [],
    },
  });

  // Watch PartyType changes
  const watchedPartyType = useWatch({
    control,
    name: "PartyType",
    defaultValue: "Customer",
  });


  const fetchAllData = (url: string) => fetchAllPaginated(url);

  // Fetch banks data
  const fetchDropdownData = async () => {
  try {
    setLoading(true);

    const [allBanks, allCustomers, allSuppliers] = await Promise.all([
      fetchAllData("banks/list"),
      fetchAllData("customers/list"),
      fetchAllData("suppliers/list"),
    ]);

    setBanks(allBanks);
    setCustomers(allCustomers);
    setSuppliers(allSuppliers);

  } catch (error) {
    console.error("Dropdown fetch error:", error);
    showMessage("Failed to load dropdown data", "error");
  } finally {
    setLoading(false);
  }
};

  // Update party options based on PartyType
  useEffect(() => {
    if (watchedPartyType === "Customer") {
      setPartyOptions(
        customers.map((cust) => ({
          value: cust.CustomerId,
          label: cust.CustomerName,
        }))
      );
      // Reset PartyId when switching to customers
      setValue("PartyId", "");
    } else if (watchedPartyType === "Supplier") {
      setPartyOptions(
        suppliers.map((sup) => ({
          value: sup.SupplierId,
          label: sup.SupplierName,
        }))
      );
      // Reset PartyId when switching to suppliers
      setValue("PartyId", "");
    }
  }, [watchedPartyType, customers, suppliers, setValue]);

  // Initial data fetch
 useEffect(() => {
  fetchDropdownData();
}, []);

  // const onSubmit = async (data: any) => {
  //   try {
  //     setLoading(true);
  //     const requestBody: ChequeData = {
  //       ChequeNumber: data.ChequeNumber?.trim() || "",
  //       ChequeDate: data.ChequeDate || new Date().toISOString(),
  //       Amount: parseFloat(data.Amount) || 0,
  //       BankId: data.BankId || "",
  //       PartyType: data.PartyType || "Customer",
  //       PartyId: data.PartyId || "",
  //       ChequeType: data.chequetype || "Received",
  //       DueDate: data.duedate || new Date().toISOString(),
  //       Remarks: data.remarks?.trim() || "",
  //     };
  //
  //     const response = await callAPI("cheques/create", Method.POST, requestBody);
  //
  //     if (response?.success) {
  //       showMessage("Cheque created successfully!", "success");
  //       navigate("/chequeentry/list");
  //     } else {
  //       showMessage(response?.message || "Operation failed", "error");
  //     }
  //   } catch (error: any) {
  //     console.error("Submit error:", error);
  //     showMessage(error?.message || "Operation failed", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const onSubmit = async (data: any) => {
    console.log('data to submit:', data);
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("ChequeNumber", data.ChequeNumber?.trim() || "");
      formData.append("ChequeDate", formatDate(data.ChequeDate));
formData.append("DueDate", formatDate(data.duedate));
      formData.append("Amount", String(parseFloat(data.Amount) || 0));
      formData.append("BankId", data.BankId || "");
      formData.append("PartyType", data.PartyType || "Customer");
      formData.append("PartyId", data.PartyId || "");
      formData.append("ChequeType", data.chequetype || "Received");
      formData.append("Remarks", data.remarks?.trim() || "");

      if (data.Attachments && data.Attachments.length > 0) {
        data.Attachments.forEach((file: File) => {
          formData.append("file", file);
        });
      }

      const response = await callAPI("cheques/create", Method.POSTFORMDATA, null,null, formData);

      if (response?.success) {
        showMessage("Cheque created successfully!", "success");
        navigate("/chequeentry/list");
      } else {
        console.log("Error response:", response);
        showMessage(response?.message || "Operation failed", "error");
      }
    } catch (error: any) {
      console.log("Submit error:", error);
      showMessage(error?.message || "Operation failed", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, background: "#ececec", minHeight: "100vh" }}>
      <Typography sx={{ fontSize: "22px", fontWeight: 600, mb: 3 }}>
        Cheque Entry
      </Typography>

      <Paper sx={{ borderRadius: "16px", p: 4, background: "#fff" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
            Cheque Details
          </Typography>
          <Box>
            <Tooltip title={isEditMode ? "Update User" : "Create User"} arrow>
                       <IconButton
                         sx={{ background: "#000", color: "#fff" }}
                         onClick={handleSubmit(onSubmit)}
                         disabled={!isValid || loading}
                       >
                         <SaveIcon fontSize="small" />
                       </IconButton>
                     </Tooltip>
          </Box>
        </Box>

        {/* First Row */}
        <Grid container spacing={4} mb={4}>  
          <Grid item xs={12} md={6}>
            <WSTextField
              name="ChequeNumber"
              label="Cheque Number"
              control={control}
              id="ChequeNumber"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <WSSelectField
              name="status"
              label="Status"
              control={control}
              id="status"
              options={config.statusConfig.staticOptionData}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <WSSelectField
              name="chequetype"
              label="Cheque Type"
              control={control}
              id="chequetype"
              options={config.chequetypeConfig.staticOptionData}
            />
          </Grid>
        </Grid>

        {/* Second Row */}
        <Grid container spacing={4} mb={4}>
          <Grid item xs={12} md={3}>
            <WSDateField
              name="ChequeDate"
              label="Cheque Date"
              control={control}
              id="ChequeDate"
              rules={undefined}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <WSSelectField
              name="BankId"
              label="Bank"
              control={control}
              inlineSearch
              id="BankId"
              options={banks.map((bank) => ({
                value: bank.BankId,
                label: bank.BankName,
              }))}
            />
          </Grid>


           <Grid item xs="auto" display="flex" alignItems="flex-start" sx={{ pl: '12px !important' }}>
  <Box
   onClick={() =>
  navigate("/chequeentry/bank", { state: { from: "chequeentry" } })
}
    sx={{
      height: "36px",
      width: "36px",
      borderRadius: "10px",
      background: "#f3f3f3",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flexShrink: 0,
      border: "1px solid #d1d5db",
      "&:hover": {
        background: "#e0e0e0",
      },
    }}
  >
    <AddIcon fontSize="small" />
  </Box>
</Grid>
          <Grid item xs={12} md={3}>
            <WSTextField
              name="Amount"
              label="Amount"
              control={control}
              id="Amount"
              type={TextType.AllowOnlyNumber}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <WSSelectField
              name="PartyType"
              label="Party Type"
              control={control}
              id="PartyType"
              options={[
                { value: "Customer", label: "Customer" },
                { value: "Supplier", label: "Supplier" },
              ]}
            />
          </Grid>
        </Grid>

        {/* Third Row */}
        <Grid container spacing={4} mb={4}>
          <Grid item xs={12} md={3}>
            <WSSelectField
              name="PartyId"
              label="Party"
              control={control}
              inlineSearch
              id="PartyId"
              options={partyOptions}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <WSDateField
              name="duedate"
              label="Due Date"
              control={control}
              id="duedate"
              rules={undefined}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <WSTextField
              name="remarks"
              label="Remarks"
              control={control}
              id="remarks"
              placeholder="Type something"
            />
          </Grid>
        </Grid>

        {/* Fourth Row - File Upload */}
        <Grid container spacing={4} mb={6}>
          <Grid item xs={12} md={3}>
            <WSFileUpload
              name="Attachments"
              label=""
              id="Attachments"
              control={control as any}
              multiple
              acceptFileTypes=".jpg,.png,.pdf,.bmp"
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ChequeEntry;
